import React from "react";
import { Player } from "./player.js";
import { FilePlayer } from "./players/file-player.js";
import { players } from "./players/index.js";
import { renderPreloadPlayers } from "./preload.js";
import { Preview } from "./preview.js";
import { DEPRECATED_CONFIG_PROPS, defaultProps, propTypes } from "./props.js";
import { getConfig, isEqual, omit } from "./utils.js";
const SUPPORTED_PROPS = Object.keys(propTypes);
let customPlayers = [];
class ReactPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.handleClickPreview = () => {
      this.setState({ showPreview: false });
    };
    this.showPreview = () => {
      this.setState({ showPreview: true });
    };
    this.getDuration = () => {
      if (!this.player) return null;
      return this.player.getDuration();
    };
    this.getCurrentTime = () => {
      if (!this.player) return null;
      return this.player.getCurrentTime();
    };
    this.getSecondsLoaded = () => {
      if (!this.player) return null;
      return this.player.getSecondsLoaded();
    };
    this.getInternalPlayer = (key = "player") => {
      if (!this.player) return null;
      return this.player.getInternalPlayer(key);
    };
    this.seekTo = (fraction, type) => {
      if (!this.player) return null;
      this.player.seekTo(fraction, type);
    };
    this.handleReady = () => {
      this.props.onReady?.();
    };
    this.wrapperRef = (wrapper) => {
      this.wrapper = wrapper;
    };
    this.activePlayerRef = (player) => {
      this.player = player;
    };
    this.config = getConfig(props, defaultProps, true);
    this.state = {
      showPreview: !!props.light
    };
  }
  componentDidMount() {
    if (this.props.progressFrequency) {
      const message = "ReactPlayer: %cprogressFrequency%c is deprecated, please use %cprogressInterval%c instead";
      console.warn(message, "font-weight: bold", "", "font-weight: bold", "");
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
  }
  componentDidUpdate(prevProps) {
    const { light } = this.props;
    this.config = getConfig(this.props, defaultProps);
    if (!prevProps.light && light) {
      this.setState({ showPreview: true });
    }
    if (prevProps.light && !light) {
      this.setState({ showPreview: false });
    }
  }
  getActivePlayer(url) {
    const allPlayers = [...customPlayers, ...players];
    for (const Player2 of allPlayers) {
      if (Player2.canPlay(url)) {
        return Player2;
      }
    }
    return FilePlayer;
  }
  renderActivePlayer(url, activePlayer) {
    if (!url) return null;
    return /* @__PURE__ */ React.createElement(
      Player,
      {
        ...this.props,
        key: activePlayer.displayName,
        ref: this.activePlayerRef,
        config: this.config,
        activePlayer,
        onReady: this.handleReady
      }
    );
  }
  sortPlayers(a, b) {
    if (a && b) {
      return a.key < b.key ? -1 : 1;
    }
    return 0;
  }
  render() {
    const {
      url,
      controls,
      style,
      width,
      height,
      light,
      playIcon,
      wrapper: Wrapper,
      previewTabIndex,
      previewAriaLabel
    } = this.props;
    const showPreview = this.state.showPreview && url;
    const otherProps = omit(this.props, SUPPORTED_PROPS, DEPRECATED_CONFIG_PROPS);
    const activePlayer = this.getActivePlayer(url);
    const renderedActivePlayer = this.renderActivePlayer(url, activePlayer);
    const preloadPlayers = renderPreloadPlayers(url, controls, this.config);
    const players2 = [renderedActivePlayer, ...preloadPlayers].sort(this.sortPlayers);
    const preview = /* @__PURE__ */ React.createElement(
      Preview,
      {
        url,
        light,
        playIcon,
        onClick: this.handleClickPreview,
        previewTabIndex,
        previewAriaLabel
      }
    );
    return /* @__PURE__ */ React.createElement(Wrapper, { ref: this.wrapperRef, style: { ...style, width, height }, ...otherProps }, showPreview ? preview : players2);
  }
}
ReactPlayer.addCustomPlayer = (player) => {
  customPlayers.push(player);
};
ReactPlayer.removeCustomPlayers = () => {
  customPlayers = [];
};
ReactPlayer.displayName = "ReactPlayer";
ReactPlayer.propTypes = propTypes;
ReactPlayer.defaultProps = defaultProps;
ReactPlayer.canPlay = (url) => {
  const allPlayers = [...customPlayers, ...players];
  for (const Player2 of allPlayers) {
    if (Player2.canPlay(url)) {
      return true;
    }
  }
  return false;
};
ReactPlayer.canEnablePIP = (url) => {
  const allPlayers = [...customPlayers, ...players];
  for (const Player2 of allPlayers) {
    if (Player2.canEnablePIP && Player2.canEnablePIP(url)) {
      return true;
    }
  }
  return false;
};
export {
  ReactPlayer
};
//# sourceMappingURL=react-player.js.map
